const AMPLITUDE_KEY_PATTERN = /^(AMP_|amp_)/;
const SESSION_REPLAY_DB_SUFFIX = "_amp_session_replay_events";
const EXPIRED = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
const IPV4_PATTERN = /^\d{1,3}(\.\d{1,3}){3}$/;

export function isAmplitudeStorageKey(name: string): boolean {
  return AMPLITUDE_KEY_PATTERN.test(name);
}

export function getCookieDomainCandidates(hostname: string): string[] {
  if (IPV4_PATTERN.test(hostname)) {
    return [hostname];
  }

  const labels = hostname.split(".");
  const candidates: string[] = [];
  for (let i = 0; i < labels.length; i++) {
    const domain = labels.slice(i).join(".");
    // bare TLD suffixes (a single label at the end, e.g. "id" from "flip.id") are excluded
    if (i === 0 || labels.length - i >= 2) {
      candidates.push(domain, `.${domain}`);
    }
  }
  return candidates;
}

function purgeCookies(): void {
  try {
    const names = document.cookie
      .split(";")
      .map((part) => part.split("=")[0].trim())
      .filter((name) => name !== "" && isAmplitudeStorageKey(name));
    const domains = getCookieDomainCandidates(window.location.hostname);
    names.forEach((name) => {
      document.cookie = `${name}=; ${EXPIRED}; path=/`;
      domains.forEach((domain) => {
        document.cookie = `${name}=; ${EXPIRED}; path=/; domain=${domain}`;
      });
    });
  } catch (error) {
    console.warn("Failed to purge Amplitude cookies", error);
  }
}

function purgeWebStorage(getStorage: () => Storage): void {
  try {
    const storage = getStorage();
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key !== null && isAmplitudeStorageKey(key)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch (error) {
    console.warn("Failed to purge Amplitude web storage", error);
  }
}

function purgeIndexedDb(): void {
  try {
    if (typeof window.indexedDB?.databases !== "function") {
      return;
    }
    window.indexedDB
      .databases()
      .then((databases) => {
        databases.forEach(({ name }) => {
          if (name && name.endsWith(SESSION_REPLAY_DB_SUFFIX)) {
            window.indexedDB.deleteDatabase(name);
          }
        });
      })
      .catch((error) => console.warn("Failed to purge Amplitude IndexedDB", error));
  } catch (error) {
    console.warn("Failed to purge Amplitude IndexedDB", error);
  }
}

export function purgeAmplitudeStorage(): void {
  purgeCookies();
  purgeWebStorage(() => window.localStorage);
  purgeWebStorage(() => window.sessionStorage);
  purgeIndexedDb();
}
